import { render, staticRenderFns } from "./Trainorderdetails.vue?vue&type=template&id=f5f4d09c&scoped=true"
import script from "./Trainorderdetails.vue?vue&type=script&lang=js"
export * from "./Trainorderdetails.vue?vue&type=script&lang=js"
import style0 from "./Trainorderdetails.vue?vue&type=style&index=0&id=f5f4d09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4d09c",
  null
  
)

export default component.exports